import React from 'react';

import { isRouteErrorResponse, useRouteError } from '@remix-run/react';
import { Button } from '~/components/ui/button';

const CustomErrorBoundary: React.FC = () => {
  const error = useRouteError();

  let errorMessage: string;
  let errorStatus: number;

  if (isRouteErrorResponse(error)) {
    errorMessage = error.data.message || 'An unexpected error occurred';
    errorStatus = error.status;
  } else if (error instanceof Error) {
    errorMessage = error.message;
    errorStatus = 500;
  } else {
    errorMessage = 'An unexpected error occurred';
    errorStatus = 500;
  }

  const isServerOverloaded = errorStatus === 503;

  return (
    <div className="flex h-screen flex-col items-center justify-center bg-gray-100">
      <div className="rounded-lg bg-white p-8 shadow-md">
        <h1 className="mb-4 text-2xl font-bold text-red-600">
          {isServerOverloaded ? 'Server Overloaded' : 'An Error Occurred'}
        </h1>
        <p className="mb-4 text-gray-700">{errorMessage}</p>
        {isServerOverloaded && (
          <p className="mb-4 text-sm text-gray-600">
            Our servers are currently experiencing high traffic. Please try again in a few moments.
          </p>
        )}
        <Button onClick={() => window.location.reload()}>Try Again</Button>
      </div>
    </div>
  );
};

export default CustomErrorBoundary;
